export const ScaleStatus = {
  Connected: 'connected',
  Disconnected: 'disconnected',
  Pending: 'pending',
};
